function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  id: "cushion"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#000000",
  strokeWidth: 0.9402,
  d: "M18.439,2.108h13.455c7.514,0,13.606,6.889,13.606,15.389v15.224 c0,8.5-6.093,15.389-13.606,15.389H18.439c-7.514,0-13.605-6.889-13.605-15.389V17.498C4.834,8.998,10.926,2.108,18.439,2.108 L18.439,2.108z"
}), /*#__PURE__*/React.createElement("polygon", {
  fill: "none",
  stroke: "#000000",
  strokeWidth: 0.9402,
  points: "25.167,12.726 32.906,16.353 36.112,25.108 32.906,33.864  25.167,37.491 17.426,33.864 14.221,25.108 17.426,16.353  "
}), /*#__PURE__*/React.createElement("polyline", {
  fill: "none",
  stroke: "#000000",
  strokeWidth: 0.9402,
  points: "4.834,25.192 10.749,18.836 14.15,25.192  "
}), /*#__PURE__*/React.createElement("polyline", {
  fill: "none",
  stroke: "#000000",
  strokeWidth: 0.9402,
  points: "4.909,15.657 10.749,18.836 17.478,16.41  "
}), /*#__PURE__*/React.createElement("polyline", {
  fill: "none",
  stroke: "#000000",
  strokeWidth: 0.9402,
  points: "17.404,16.327 19.622,8.967 9.124,6.29 10.749,18.836  "
}), /*#__PURE__*/React.createElement("polyline", {
  fill: "none",
  stroke: "#000000",
  strokeWidth: 0.9402,
  points: "25.167,12.73 19.696,9.05 16.664,2.192  "
}), /*#__PURE__*/React.createElement("line", {
  fill: "none",
  stroke: "#000000",
  strokeWidth: 0.9402,
  x1: 25.167,
  y1: 2.108,
  x2: 19.696,
  y2: 9.05
}), /*#__PURE__*/React.createElement("polyline", {
  fill: "none",
  stroke: "#000000",
  strokeWidth: 0.9402,
  points: "45.5,25.192 39.584,18.836 36.184,25.192  "
}), /*#__PURE__*/React.createElement("polyline", {
  fill: "none",
  stroke: "#000000",
  strokeWidth: 0.9402,
  points: "45.425,15.657 39.584,18.836 32.856,16.41  "
}), /*#__PURE__*/React.createElement("polyline", {
  fill: "none",
  stroke: "#000000",
  strokeWidth: 0.9402,
  points: "32.931,16.327 30.713,8.967 41.211,6.29 39.584,18.836  "
}), /*#__PURE__*/React.createElement("polyline", {
  fill: "none",
  stroke: "#000000",
  strokeWidth: 0.9402,
  points: "25.167,12.73 30.638,9.05 33.67,2.192  "
}), /*#__PURE__*/React.createElement("line", {
  fill: "none",
  stroke: "#000000",
  strokeWidth: 0.9402,
  x1: 25.167,
  y1: 2.108,
  x2: 30.638,
  y2: 9.05
}), /*#__PURE__*/React.createElement("polyline", {
  fill: "none",
  stroke: "#000000",
  strokeWidth: 0.9402,
  points: "45.5,25.025 39.584,31.381 36.184,25.025  "
}), /*#__PURE__*/React.createElement("polyline", {
  fill: "none",
  stroke: "#000000",
  strokeWidth: 0.9402,
  points: "45.425,34.561 39.584,31.381 32.856,33.809  "
}), /*#__PURE__*/React.createElement("polyline", {
  fill: "none",
  stroke: "#000000",
  strokeWidth: 0.9402,
  points: "32.931,33.891 30.713,41.25 41.211,43.927 39.584,31.381  "
}), /*#__PURE__*/React.createElement("polyline", {
  fill: "none",
  stroke: "#000000",
  strokeWidth: 0.9402,
  points: "25.167,37.486 30.638,41.167 33.67,48.023  "
}), /*#__PURE__*/React.createElement("line", {
  fill: "none",
  stroke: "#000000",
  strokeWidth: 0.9402,
  x1: 25.167,
  y1: 48.107,
  x2: 30.638,
  y2: 41.167
}), /*#__PURE__*/React.createElement("polyline", {
  fill: "none",
  stroke: "#000000",
  strokeWidth: 0.9402,
  points: "4.834,25.025 10.749,31.381 14.15,25.025  "
}), /*#__PURE__*/React.createElement("polyline", {
  fill: "none",
  stroke: "#000000",
  strokeWidth: 0.9402,
  points: "4.909,34.561 10.749,31.381 17.478,33.809  "
}), /*#__PURE__*/React.createElement("polyline", {
  fill: "none",
  stroke: "#000000",
  strokeWidth: 0.9402,
  points: "17.404,33.891 19.622,41.25 9.124,43.927 10.749,31.381  "
}), /*#__PURE__*/React.createElement("polyline", {
  fill: "none",
  stroke: "#000000",
  strokeWidth: 0.9402,
  points: "25.167,37.486 19.696,41.167 16.664,48.023  "
}), /*#__PURE__*/React.createElement("line", {
  fill: "none",
  stroke: "#000000",
  strokeWidth: 0.9402,
  x1: 25.167,
  y1: 48.107,
  x2: 19.696,
  y2: 41.167
})));

const SvgBrilliant = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  id: "Layer_1",
  x: "0px",
  y: "0px",
  width: "50px",
  height: "50px",
  viewBox: "0 0 50 50",
  enableBackground: "new 0 0 50 50",
  xmlSpace: "preserve",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref);

const ForwardRef = React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgBrilliant, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/brilliant.5edbbbf3.svg";
export { ForwardRef as ReactComponent };